import { JWT_KEY } from "Auth/Models/AuthConstants";
import { useLogoutZfpSso } from "Infrastructure/ApiZfp/AnalyzerApi";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { toast } from "sonner";

export function useSignOut() {
  const { t } = useResource();
  const { refetch: fetchLogoutUrl } = useLogoutZfpSso(
    { redirectUrl: `${window.location.protocol}//${window.location.host}` },
    { query: { enabled: false } },
  );

  return async () => {
    localStorage.removeItem(JWT_KEY);
    try {
      const { data } = await fetchLogoutUrl();
      if (data?.url) {
        window.location.replace(data.url);
      } else {
        toast.error(t(Resources.AnalysisDetail.Toast.ActionError));
      }
    } catch {
      toast.error(t(Resources.AnalysisDetail.Toast.ActionError));
    }
  };
}
